import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "custom-trigger-field" }

import { computed } from "vue";
import type { PerformanceClip } from "../../types/DialogueNode";
import { createClipComponent } from "../../config/clipComponentRegistry";

export default /*@__PURE__*/_defineComponent({
  __name: 'CustomClipEditor',
  props: {
    clip: {}
  },
  setup(__props: any) {

const props = __props;
const triggerValue = computed({
  get: () => {
    const value = props.clip.components.find(component => component.templateId === "custom.data")?.properties.value;
    return typeof value === "string" ? value : "";
  },
  set: (value: string) => {
    let config = props.clip.components.find(component => component.templateId === "custom.data");
    if (!config) { config = createClipComponent("custom.data"); props.clip.components.push(config); }
    config.enabled = true;
    config.properties.value = value.replace(/[\r\n]/g, "");
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _cache[1] || (_cache[1] = _createTextVNode("自定义触发字符串 ", -1)),
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((triggerValue).value = $event)),
      type: "text",
      "aria-label": "自定义触发字符串",
      placeholder: "输入触发参数"
    }, null, 512), [
      [_vModelText, triggerValue.value]
    ])
  ]))
}
}

})